import { deviceReducer } from './devices/devices.reducer';
export var rtcReducers = {
    ioDevices: deviceReducer
};
//# sourceMappingURL=rtc.reducers.js.map